import { render, staticRenderFns } from "./MyUpload.vue?vue&type=template&id=dcd1faba&scoped=true&"
import script from "./MyUpload.vue?vue&type=script&lang=js&"
export * from "./MyUpload.vue?vue&type=script&lang=js&"
import style0 from "./MyUpload.vue?vue&type=style&index=0&id=dcd1faba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd1faba",
  null
  
)

export default component.exports